// stores/user.js
import { defineStore } from "pinia";
import api from "@/services/api";

export const useUserStore = defineStore("user", {
  state: () => ({
    currentProfile: null,
    loading: false,
    error: null,
  }),

  actions: {
    async getUserProfile(userId) {
      try {
        this.loading = true;
        const response = await api.get(`/users/${userId}`);
        return { success: true, data: response.data.data };
      } catch (error) {
        this.error = error.message;
        return { success: false, error: error.message };
      } finally {
        this.loading = false;
      }
    },

    async toggleFollow(userId) {
      try {
        const response = await api.post(`/users/${userId}/follow`);
        return { success: true, data: response.data.data };
      } catch (error) {
        this.error = error.message;
        return { success: false, error: error.message };
      }
    },

    async updateProfile(profileData) {
      try {
        const response = await api.put("/users/me", profileData);
        return { success: true, data: response.data.data };
      } catch (error) {
        this.error = error.message;
        return { success: false, error: error.message };
      }
    },

    async getFollowers(userId) {
      try {
        const response = await api.get(`/users/${userId}/followers`);
        return { success: true, data: response.data.data };
      } catch (error) {
        this.error = error.message;
        return { success: false, error: error.message };
      }
    },

    async getFollowing(userId) {
      try {
        const response = await api.get(`/users/${userId}/following`);
        return { success: true, data: response.data.data };
      } catch (error) {
        this.error = error.message;
        return { success: false, error: error.message };
      }
    },
  },
});
